export const ids = [
	'estimating',
	'preliminary-design',
	'final-design',
	'consent',
	'conversion',
	'rough-estimate', // [ROME-2984] for Kora Components
	'revision', // [ROME-3373] UK
	'seals', // [ROME-3979] The Truss Company
	'order',
	'ai-frame-file',
	'estimate-to-order', // ROME-7188 FBS
] as const;
